import type { FormSurface } from "../store";
import { FormResponseDialogWizard } from "./FormResponseDialogWizard";
import { PinnedFormDialogWizard } from "./PinnedFormDialogWizard";
import { FormLinkWizard } from "./FormLinkWizard";
import type { SurfaceWizardProps } from "./types";

export interface EnduserFormWizardProps extends SurfaceWizardProps {
  /**
   * Which surface is rendering the form. Each has its own store, so two forms open at once cannot
   * overwrite each other, and each persists differently — the deeplink keeps its state in the URL
   * while the in-app dialogs stay in memory.
   */
  surface: FormSurface;
}

/**
 * Renders the enduser form wizard for a given surface.
 *
 * The store cannot be chosen inside the wizard body, since selecting a hook at runtime would mean
 * calling hooks conditionally. Each surface instead has its own component that calls its store hook
 * unconditionally and hands it to the shared body.
 */
export const EnduserFormWizard = ({ surface, ...props }: EnduserFormWizardProps) => {
  switch (surface) {
    case "form-response-dialog":
      return <FormResponseDialogWizard {...props} />;
    case "pinned-form-dialog":
      return <PinnedFormDialogWizard {...props} />;
    case "form-link":
      return <FormLinkWizard {...props} />;
  }
};
